import { Flex } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Header from '../../../../components/Header';
import Form, { FormResult } from './components/Form';
import locales from './locales';

const MORE_INFO_URL =
  'https://help.shine.fr/fr/articles/2771398-pourquoi-shine-me-demande-mon-patrimoine-et-mon-revenu-annuel';

interface ComplianceFormProps {
  isSubmitting: boolean;
  initialValues: Partial<FormResult>;
  onSubmit: (values: FormResult) => void;
}

/**
 * A page that asks for the user’s compliance info
 */
const ComplianceForm = asBentoPage<ComplianceFormProps>(
  ({ initialValues, isSubmitting, Layout, onPrev, onSubmit }) => (
    <Layout data-testid="compliance" nav={<OBNavigation onPrev={onPrev} />}>
      <Flex direction="column" height="full">
        <Header
          description={locales.headerDescription}
          linkIcon="information"
          linkText={locales.linkLabelKnowMore}
          linkUrl={MORE_INFO_URL}
          title={locales.title}
        />

        <Form
          initialValues={initialValues}
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
        />
      </Flex>
    </Layout>
  ),
);

export default ComplianceForm;
